import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { serverurl } from '../../environments/environment';
import { UserEngagement } from '../lib/interfaces/user-engagement.interface';

@Injectable({
    providedIn: 'root'
})
export class UserEngagementService {

    private httpClient = inject(HttpClient)

    public getUserEngagement(
        startMonth: number | null,
        startYear: number | null,
        endMonth: number | null,
        endYear: number | null,
    ): Observable<UserEngagement[]> {
        if (!startMonth || !startYear || !endMonth || !endYear) {
            return throwError(() => new Error('Month and year are required'));
        }

        let params = new HttpParams();

        params = params.append('startMonth', startMonth.toString());
        params = params.append('startYear', startYear.toString());
        params = params.append('endMonth', endMonth.toString());
        params = params.append('endYear', endYear.toString());

        return this.httpClient.get<UserEngagement[]>(
            `${serverurl}/dashboard/report/user-engagement`,
            { params },
        );
    }
}
